export const services = [
  {
    id: "app-development",
    title: "Innovative Mobile App Development for your business needs",
    description: "We create custom mobile apps using technologies like React Native, Flutter, Swift, Kotlin, and AWS to deliver high-performance, secure, and scalable solutions.",
    stats: [
      { value: "500k", label: "New Users" },
      { value: "10K+", label: "Downloads" }
    ]
  },
  {
    id: "creative-designs",
    title: "Designs that inspire, engage, and leave a lasting impression",
    description: "We specialize in creating designs that not only capture attention but also inspire and engage your audience. From branding to web design, we deliver stunning results.",
    stats: [
      { value: "500+", label: "Designs Delivered" },
      { value: "95%", label: "Satisfaction Rate" }
    ]
  },
  {
    id: "blockchain-development",
    title: "Transform your business with blockchain technology",
    description: "We specialize in creating secure and transparent blockchain solutions, from smart contracts to cryptocurrency platforms.",
    stats: [
      { value: "50+", label: "Blockchain Solutions Delivered" },
      { value: "40%", label: "Lower Transaction Costs" }
    ]
  },
  {
    id: "erp-solutions",
    title: "Streamlining your business operations with ERP Solutions",
    description: "We deliver customized, scalable ERP systems tailored to your unique business needs, ensuring smoother workflows and better decision-making.",
    stats: [
      { value: "50", label: "ERP Implementations" },
      { value: "30%", label: "Increase in Operational Efficiency" }
    ]
  },
  {
    id: "web-development",
    title: "Building dynamic, user-friendly websites that engage & convert",
    description: "We build responsive, visually appealing websites that perform flawlessly on all devices, using the latest technologies for security and optimal UX.",
    stats: [
      { value: "200+", label: "Websites Delivered" },
      { value: "98%", label: "Customer Satisfaction" }
    ]
  },
  {
    id: "digital-marketing",
    title: "Drive measurable growth with tailored digital marketing campaigns",
    description: "Our digital marketing strategies use SEO, PPC, social media, and email marketing to increase brand visibility and drive measurable results.",
    stats: [
      { value: "30%", label: "Higher Conversion Rates" },
      { value: "$1M+", label: "Revenue Generated" }
    ]
  },
  {
    id: "ai-development",
    title: "Drive business efficiency with artificial intelligence solutions",
    description: "We leverage AI to automate tasks, predict trends, and improve customer experiences, driving innovation and efficiency across your business.",
    stats: [
      { value: "20+", label: "AI Solutions Delivered" },
      { value: "15%", label: "Reduction in Operational Costs" }
    ]
  },
  {
    id: "content-marketing",
    title: "Empowering brands with strategic content marketing that drives results",
    description: "We create engaging content that resonates with your audience, builds trust, and boosts conversions.",
    stats: [
      { value: "500+", label: "Content Pieces Created" },
      { value: "40%", label: "Boost in Lead Generation" }
    ]
  }
];

export const serviceTabs = [
  "App development",
  "Creative designs",
  "Blockchain development",
  "ERP solutions",
  "Web development",
  "Digital marketing",
  "AI development",
  "Content marketing"
];

export const caseStudies = [
  {
    id: 1,
    title: "Digital Transformation for FinServe Global",
    description: "Digitronix Consultancy engineered a comprehensive fintech dashboard that unified portfolio management, real-time market analytics, and automated compliance reporting — reducing manual effort by 70%.",
    tags: ["UI/UX Design", "Full-Stack Development", "Data Analytics"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop"
  },
  {
    id: 2,
    title: "Complete Brand Overhaul for NovaTech",
    description: "We reimagined NovaTech's entire digital presence — from brand identity and website to their internal tools — resulting in 3X increase in qualified leads within the first quarter.",
    tags: ["Brand Strategy", "Web Platform", "Growth Marketing"],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop"
  },
  {
    id: 3,
    title: "Scalable E-Commerce for Urban Collective",
    description: "Built a high-performance e-commerce platform handling 100K+ concurrent users with AI-powered recommendations, achieving 45% higher average order value.",
    tags: ["E-Commerce", "AI Integration", "Cloud Architecture"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=500&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Digitronix completely transformed our operations. Their digital solutions reduced processing time by 60% and gave us visibility we never had before.",
    name: "Marcus Chen",
    role: "CEO, TechVault Inc.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 2,
    quote: "The mobile app they developed for us exceeded every expectation. Downloads hit 50K in the first month and user retention is at 78%.",
    name: "Priya Sharma",
    role: "Product Director, NovaPay",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 3,
    quote: "Their AI-powered analytics platform gave us insights we never thought possible. Revenue increased 40% within six months of implementation.",
    name: "James Whitfield",
    role: "COO, DataBridge Solutions",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 4,
    quote: "Working with Digitronix was seamless from day one. Their team understood our vision and delivered a platform that our users genuinely love.",
    name: "Aisha Al-Mansoor",
    role: "Managing Director, GulfTech Group",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face"
  }
];

export const blogPosts = [
  {
    id: 1,
    category: "AI Solutions",
    date: "Jan 15, 2026",
    number: "001",
    title: "Guide to choosing your AI partner",
    slug: "guide-to-choosing-your-ai-partner",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=500&h=350&fit=crop"
  },
  {
    id: 2,
    category: "Digital Strategy",
    date: "Jan 10, 2026",
    number: "002",
    title: "Redefining Customer Experience",
    slug: "redefining-customer-experience",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=500&h=350&fit=crop"
  },
  {
    id: 3,
    category: "Cloud Solutions",
    date: "Dec 28, 2025",
    number: "003",
    title: "Engagement with Cloud Services",
    slug: "engagement-with-cloud-services",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=500&h=350&fit=crop"
  },
  {
    id: 4,
    category: "Web Development",
    date: "Dec 15, 2025",
    number: "004",
    title: "Building Scalable Web Platforms",
    slug: "building-scalable-web-platforms",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=500&h=350&fit=crop"
  }
];

export const awards = [
  { id: 1, name: "INC. 5000", subtitle: "America's Fastest Growing Companies" },
  { id: 2, name: "Clutch", subtitle: "Top 1000 Companies" },
  { id: 3, name: "Top Developers", subtitle: "Top Enterprise App Developers" },
  { id: 4, name: "Expertise", subtitle: "Best Digital Consultancy" },
  { id: 5, name: "Software World", subtitle: "Top Development Companies" },
  { id: 6, name: "GoodFirms", subtitle: "Top IT Consulting Firm" }
];

export const stats = [
  { value: "99%", description: "on-time project delivery with zero scope creep." },
  { value: "95%", description: "client satisfaction across all delivered solutions." },
  { value: "3X", description: "average revenue growth for our long-term partners." },
  { value: "200+", description: "enterprise-grade applications shipped globally." }
];

export const footerLinks = {
  quickLinks: [
    { label: "About Us", href: "/about" },
    { label: "Contact Us", href: "/contact" },
    { label: "Blogs", href: "#" },
    { label: "Careers", href: "#" }
  ],
  presence: [
    { label: "United States", href: "#" },
    { label: "Middle East", href: "#" },
    { label: "United Kingdom", href: "#" }
  ]
};
